var lists_default = {
  "fontElementMap": "m2jUi",
  "orderedlist": "ibnNV",
  "bulletedlist": "d7Kkd",
  "listItem": "Hrp38"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
